import rpAPI from "@shared/service/rpAPI";
import settings from "./Settings";
import Globals from "./Globals";
import { DialogDescription } from "@headlessui/vue";
import { tags } from "liquidjs";




class Order {
    constructor(reservation) {
        this.currentStep = 0;
        this.reservation = reservation;
        this.term = null;
        this.customer = null;
        this.agreements = [];
        this.addons = [];
        this.age = {};
        this.insurance = { price: 0 };
        this.participants = [];
        this.count = {'all': 0};
        this.number = null;
        this.totalAmount = 0;
        this.insuranceAmount = 0;
        this.advanceAmount = 0;
        this.dueDate = null;
        this.advanceDueDate = null;
        this.remainingAmount = 0;
        this.price = 0;
        this.addPrice = 0;
        this.remarks = "";
        this.onTrial = false;
        this.sendOrder = {};
       
        // RLO, Normalizacja wieku jeśli mamy ceny w zalenśości od wieku
        // W innym wypadku this.age będzie pustye i trzeba patrzeć na wybraną grupę
        if (this.reservation?.price != null) {
            this.reservation?.price?.forEach(price => {
                if (!price.age_max) {
                    price.age_max = this.reservation.age_max;
                }
                if (!price.age_min) {
                    price.age_min = this.reservation.age_min;
                }
                this.age[price.category] = { min: price.age_min, max: price.age_max };
            });
        } 

    }

    getCount(category = null) {
         // Return the count for the specified category, or 0 if it doesn't exist
         if (category != null) {
             return this.count[category] || 0;
         } else {
             // If no category is specified, return the total count
             return Object.values(this.count).reduce((a, b) => a + b, 0);
         }
    }

    getParticipiantsPrice() {
        let price = 0;
        for (const [category, count] of Object.entries(this.count)) {
            let categoryPrice = this.reservation.basePrice;
            if (this.reservation?.price !== null) {
                let category = this.reservation?.price?.find(p => p.category === category) ?? null;
                if (category) {
                    categoryPrice = category.price;
                }
            }
            if (this.selectedGroup !== null) {
                categoryPrice = this.selectedGroup?.price > 0 ? this.selectedGroup?.price : categoryPrice;
            }
            if (categoryPrice > 0 && count > 0) {
                price += categoryPrice * count;
            }
        }
        return price ?? 0;
    }

    getSinglePrice(category, age) {
        // if (this.reservation?.price != null) {
        //     const categoryPrice = this.camp.price.find(p => p.category === category && p.age_min <= age && p.age_max >= age);
        //     return categoryPrice?.price ?? 0;
        // } else {
        //     return this.selectedGroup?.price ?? 0;
        // }   
        return this.selectedGroup?.price ?? 0;
    }

    getInstallmentPrice() {
        let installment = 0;
        // for (const [category, count] of Object.entries(this.count)) {
        //     const categoryPrice = this.camp.price.find(p => p.category === category);
        //     if (categoryPrice) {
        //         if (categoryPrice.installment)
        //             installment += categoryPrice.installment * count;
        //     }
        // }

        // if (isNaN(installment)) {
        //     installment = 0;
        // }

        return installment;
    }

    getAddOnsPrice() {
        let price = 0;
        for (const addon of this.addons) {
            if (addon.price && addon.price) {
                price += addon.price * addon.quantity;
            }
        }

        if (isNaN(price)) {
            price = 0;
        }

        return price;
    }

    getInsuranceAmount() {
        let price = 0;
        if (this.insurance && this.insurance.price) {
            price = this.insurance.price;
        }

        if (isNaN(price)) {
            price = 0;
        }

        return price;
    }

    getTotalAmount() {
        let amount = 0;
        if (this.selectedGroup.payment_type && this.selectedGroup.payment_type === 'monthly') {
            // discount tylko na pierwsze zamówienie
            amount = this.getMonthCount() * this.getMonthlyAmount() + this.getAddOnsPrice() + this.getInsuranceAmount() - this.getDiscountAmount();
        } else { 
            amount = (this.getParticipiantsPrice() + this.getAddOnsPrice() + this.getInsuranceAmount() - this.getDiscountAmount());
        };
    
        
        if (isNaN(amount)) {
            return 0;
        }
        if (amount <= 0)
            return 0;
        else
            return amount;
        
    }

    getMonthCount() {
        return this.selectedGroup?.months.length || 1;
    }

    getMonthlyAmount() {
        if (this.selectedGroup.payment_type === 'monthly') {
            return this.getParticipiantsPrice(); 
        }
        return 0;
    }

    setTerm(selected) {
        if (this) {
            this.term = selected || null;
            if (this.term.free_seats > 0 && this.term.free_seats <= settings.low_number_of_participiants_warning) {
                this.term.auto_confirm = false;
            }
        }
    }

    setGroup(selected) {
        if (this) {
            this.selectedGroup = selected || null;
            if (this.selectedGroup.lowAvailability) {
                this.selectedGroup.auto_confirm = false;
            }
            this.age['all'] = {
                min: this.selectedGroup?.age_min,
                max: this.selectedGroup?.age_max
            };
            // we always set early bird eligibility on group change, because we can change to group without early birds or with different early birds
            this.setIsEligibleEarlyBird(false);
          }
    }


    setCount(category, c) {
        const maxCount = settings.max_number_of_participants;
        if (c <= maxCount) {
            if (this) {
                this.count[category] = c || 0;
            }
        }
    }

    setAddOns(selected) {
        if (this) {
            this.addons = selected || [];

        }
    }

    setInsurance(selected) {
        if (this) {
            console.log('updateInsurance:', selected);
            this.insurance = selected || { price: 0 };
        }
    }

    setCustomer(customer) {
        if (this) {
            this.customer = customer;
            if (this.customer.isInitialized && typeof this.customer.isInitialized === 'function' ) {
                this.customer.initProfiles();
            }
        }
    }

    setAgreements(agreements) {

        if (this) {
            // map agreements to array of title and acceptance with date
            agreements = agreements.map(a => {
                return {
                    id: a.id,
                    title: a.title,
                    condition: a.condition,
                    required: a.required,
                    content: a.content,
                    acceptance: a.acceptance === true ? "Akceptacja" : a.acceptance,
                    accepted_date: a.accepted_date
                };
            });
            this.agreements = agreements || [];
        }
    }

    setParticipantFromCustomer(customer) {
        if (this && customer) {
            const p = {
                first_name: customer.first_name || "",
                last_name: customer.last_name || "",
                profile: customer.profile || {}
            };
            this.participants = this.participants || [];
            this.participants.push(p);
        }
    }

setParticipants(participants) {

        if (this) {
            this.participants = participants || [];
            // for each participant profile convert profile which is in form of key, value to array of key, value
            this.participants = this.participants.map(p => {
                p.user_profile = p.id;
                const profile = p.profile;
                p.profile_string = Object.keys(profile).map(key => {
                    return key + "," + profile[key];
                }).join('|');
                return p;
            });
        }
    }

    getParticipiantsList() {
        // rerurn list of participants firstname, lastname, age, phone, email
        const pList = this.participants.map(p =>
            p.first_name + " " + p.last_name);
        return pList.join(", ");
    }

    saveOrder() {
        rpAPI.setStorageItem('order', JSON.stringify(this), true);
    }

    setOnTrial(onTrial) {
        if (this) {
            this.onTrial = onTrial;
        }
    }

    clearOrder() {
        rpAPI.clearStorageItem('order', true);
        this.currentStep = 0;
        this.count = {};
        this.discount = 0;
        this.participants = [];
        this.customer = {};
        this.addons = [];
        this.insurance = {};
        this.agreements = [];
        this.onTrial = false;
        this.sendOrder = {};

    }

    // RLO we are coping only session related data
    copyOrder(order) {
        this.currentStep = order.currentStep;
        this.count = order.count;
        this.discount = order.discount;
        this.participants = order.participants;
        this.customer = order.customer;
        this.addons = order.addons;
        this.insurance = order.insurance;
        this.agreements = order.agreements;
    }

    static getSavedOrder() {

        const savedOrder = rpAPI.getStorageItem('order', true);
        if (savedOrder) {
            const orderData = JSON.parse(savedOrder);
            return orderData;
        }

        return null;
    }


    async genContractContent() {

        if (!this.selectedGroup.contract.is_pdf_generated)
            return true;

        this.totalAmount = this.getTotalAmount();

        // RLO, inne wyliczanki

        // this.advanceAmount = this.getInstallmentPrice() + this.getInsuranceAmount();
        // this.remainingAmount = this.getTotalAmount() - this.advanceAmount;
        // this.addOnsAmount = this.getAddOnsPrice();
        // this.dueDate = this.getDueDate();
        // this.advanceDueDate = this.getAdvancePaymentDate();
        // this.insuranceAmount = this.getInsuranceAmount();

        if (!this.selectedGroup || !this.selectedGroup.contract) {
            throw new Error('Nie znaleziono szablonu umowy dla wybranej grupy.');
        }

        console.log(this.getDetails());
        try {
            const response = await fetch(`${rpAPI.projectApiBase}rlo2pdf/print`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...(rpAPI.token?.access_token ? { 'Authorization': `Bearer ${rpAPI.token.access_token}` } : {})
                },
                body: JSON.stringify({
                    data: this.getDetails(),
                    body: this.selectedGroup.contract.body, // RLO, przydałaby się obsługa footer i header
                })
            });

            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            // take whole body  as text
            const data = await response.json();
            return data.html;
        } catch (error) {
            console.error('Contract generate error:', error);
            return false;
        }
    }

    setEligibility(eligible) {
        this.eligible = !!eligible;
    }

    setEarlyBirdEligibility(earlyBirdEligible) {
        this.earlyBirdEligible = !!earlyBirdEligible;
    }

    // wszystkie szczegóły do umowy i do odtworzenia zamówienia
    getDetails() {
        return {
            order_number: this.number,
            contract: this.selectedGroup?.contract?.id,
            date: this.date,
            count: this.count,
            payment_type: this.selectedGroup?.payment_type || 'one_time',
            discount_amount: this.getDiscountAmount(),
            advance_amount: this.getAdvanceAmount(),
            total_amount: this.getTotalAmount(),
            monthly_amount: this.getMonthlyAmount(),
            insurance_amount: this.getInsuranceAmount(),
            currency: this.selectedGroup?.currency || this.reservation?.currency || 'PLN',

            remaining_amount: this.getTotalAmount(),
            due_amount: this.getTotalAmount(),  // tutaj powinniścmy wyliczyć czy zaliczka czy całość
            advanced_due_amount: this.getAdvanceAmount(),
            addon_amount: this.getAddOnsPrice(),
            due_date: this.getDueDate(),
            advanced_amount: this.getAdvanceAmount(),
            advanced_due_date: this.getAdvancePaymentDate(),
            due_date: this.getDueDate(),
            remarks: this.remarks.trim(),
            agreements: this.agreements,
            addons: this.addons,
            insurance: this.insurance,
            participants: this.participants,
            participants_count: this.getCount(),
            
            reservation: {
                id: this.reservation.id,
                name: this.reservation.name,
                thumb: this.reservation.thumb,
            },
            payment: {
                id: this.selectedGroup?.payment?.id,
                method: this.selectedGroup?.payment?.method,
                company: this.selectedGroup?.payment?.company,
                description: this.selectedGroup?.payment?.description,
                payment_link: this.selectedGroup?.payment?.payment_link,
                bank_account: this.selectedGroup?.payment?.bank_account,
                lineItems: [{
                        // RLO, AKA specific
                        "name": "Warsztaty artystyczne",
                       // "name": this.selectedGroup?.name?.trim(),
                        // "description": ,
                        "quantity": this.getCount(),
                        "unit_price": this.getParticipiantsPrice()}],
            },
            group: {
                id: this.selectedGroup.id,
                thumb: this.selectedGroup.thumb,
                name: this.selectedGroup.name,
                price: this.selectedGroup.price,
                age_min: this.selectedGroup.age_min,
                age_max: this.selectedGroup.age_max,
                start_date: this.selectedGroup.start_date,
                end_date: this.selectedGroup.end_date,
                dance: this.selectedGroup.dance?.title,
                level: this.selectedGroup.level?.title,
                tags: this.selectedGroup.tags || [],
                age: this.selectedGroup.age?.title,
                year: this.selectedGroup.year,
                hours: this.selectedGroup.hours,
                months: this.selectedGroup?.months || [],
                instructors: this.selectedGroup?.instructors?.map(i => ({ fullName: i.fullName, image: i.image })) || [],
            },
            location: {
                id: this.selectedGroup.location.id,
                name: this.selectedGroup.location.name,
                address: this.selectedGroup.location.address,
                city: this.selectedGroup.location.city,
            },
            customer: {
                id: this.customer.id,
                first_name: this.customer.first_name,
                last_name: this.customer.last_name,
                email: this.customer.email,
                phone: this.customer.phone,
                address: this.customer.address,
                city: this.customer.city,
                postalcode: this.customer.postalcode,
                country: this.customer.country,
                
                needs_company: this.customer.needs_company,
                company_name: this.customer.company_name,
                company_tax: this.customer.company_tax,
                company_address: this.customer.company_address,
                company_city: this.customer.company_city,
                company_postalcode: this.customer.company_postalcode,
            },
            offDays: settings.offDays[this.selectedGroup.year] || [],
        };
    }

    getDiscountAmount() {
        let discount = 0;
         if (this && this.discount) {
            const total = this.getParticipiantsPrice() + this.getAddOnsPrice() + this.getInsuranceAmount();
            if (this.discount.type === 'percent') {
                discount = Math.ceil((total * parseFloat(this.discount.value) || 0));
            } else if (this.discount.type === 'value') {
                discount = parseFloat(this.discount.value) || 0;
            } else {
                discount = 0;
            }
        }
 
        if (isNaN(discount)) {
            discount = 0;
        }
        if (discount < 0) {
            discount = 0;
        }
        return discount;
    }

    removeDiscount() {
        if (this) {
            this.discount = null;
        }
    }

    setDiscount(discount) { 
        if (this) {
            this.discount = discount;
        }
    }

    async applyDiscount(code) {

        if (code == null || code === "") {
            this.setDiscount(null);
            return null;
        }

        try {

            const discount = await rpAPI.getCoupon(code);
            if (discount) {
                console.log('applyDiscount:', discount);
                const status = discount.status;

                const expireDate = discount.date_expired
                    ? (() => {
                        const d = new Date(discount.date_expired);
                        d.setHours(23, 59, 59, 999);
                        return d;
                    })()
                    : null;
                const limit = discount.limit ? discount.limit : null;
                const used = discount.used ? discount.used : 0;
                const limitNewCustomerOnly = discount.only_new_customers;
                const limitExistingCustomerOnly = discount.only_existing_customers;
                const limitTerms = Array.isArray(discount.terms) ? discount.terms.map(term => term.ClassOffer_id) : [];

                // validate discount
                if (status !== 'published') {
                    throw Error('Kod rabatowy jest nieaktywny.');
                }
                if (expireDate && expireDate < new Date()) {
                    throw Error('Kod rabatowy wygasł.');
                }
                if (limit && used >= limit) {
                    throw Error('Limit na kod rabatowy został wykorzystany.');
                }

                if (limitNewCustomerOnly && this.customer?.id == null)  {
                        throw Error('Kod rabatowy dla nowych klientów. Użyj go po zalogowaniu.');
                }

                if (limitExistingCustomerOnly && this.customer?.id == null) {
                        throw Error('Kod rabatowy dla klientów. Użyj go po zalogowaniu.');
                }
                if (limitExistingCustomerOnly && this.customer?.orders?.length == 0 ) {
                        throw Error('Kod rabatowy dostępny jest wyłącznie dla klientów, którzy złożyli zamówienie.');
                }
                if (limitExistingCustomerOnly && this.customer?.orders?.length == 0 ) {
                        throw Error('Kod rabatowy jest tylko dla klientów.');
                }
                if (limitTerms.length > 0 && !limitTerms.includes(this.selectedGroup.id)) {
                    throw Error('Kod rabatowy nie jest dostępny dla tej oferty.');
                }
                

                this.setDiscount(discount);
                return discount;
            } else {
                throw Error('Nie znaleziono kodu rabatowego.');
            }

        } catch (error) {
            console.error('Discount apply error:', error);
            throw error;
        }
        return null;
    }

    async confirmOrder() {
        const cParticipantsPage = 6; 
        const cRegisterPage = 5;

       

        
        // walidacja przed wysłaniem zamówienia
        if (this.participants.length == 0) {
            alert('Brak uczestników w zamówieniu. Cofnij się i dodaj uczestników.');
            return cParticipantsPage;
        }
        if (this.customer == null || this.customer?.first_name == null || this.customer?.last_name == "") {
            alert('Brak danych klienta w zamówieniu. Cofnij się do strony klienta i uzupełnij dane.');
            return cRegisterPage;
        }

        const addonInfoString = this.addons
        .map(addon => `${addon.name} x ${addon.quantity}`)
        .join(', ');
        this.totalAmount = this.getTotalAmount();
        // this.advanceAmount = this.getInstallmentPrice() + this.getInsuranceAmount();
        // this.remainingAmount = this.getTotalAmount() - this.advanceAmount;
        // this.addOnsAmount = this.getAddOnsPrice();
        // this.discountAmount = this.getDiscountAmount();
        // this.dueDate = this.getDueDate();
        // this.advanceDueDate = this.getAdvancePaymentDate();
        // this.insuranceAmount = this.getInsuranceAmount();
        const rodo = this.agreements.find(a => a.condition === 'RODO');
        const rodoAcceptance = rodo?.acceptance ?? "Brak";
        const participiants_keywords = this.selectedGroup.name + ',' + this.selectedGroup.location.name;

        const participiants = this.participants.map(p => {
            return {
                "user_profile": p.user_profile,
                "group": this.selectedGroup.id,
                "first_name": p.first_name,
                "last_name": p.last_name,
                "pesel": p.pesel,
                "nationality": p.nationality,
                "gender": p.gender,
                "date_of_birth": p.date_of_birth,
                "age": p.age,
                "profile": p.profile,
                "profile_info": Object.entries(p.profile || {}).map(([key, value]) => `${key}:${value}`).join(','),
                "addons": addonInfoString,
                "remarks": this.remarks,
                "rodo": rodoAcceptance,
                "keywords": participiants_keywords.substring(0, 255),
            };
        }
        );
 
        let status = (this.selectedGroup.autoConfirm) ? 'confirmed' : 'new';
        if (this.onTrial) {
            status = 'trial';
        }
        if (this.selectedGroup.paymentRequired) {
            status = 'pending_payment';
        }

        const order_keywords = this.customer.first_name + ',' + this.customer.last_name + ',' + this.customer.phone + ',' + this.customer.email + ',' + this.customer.company_name + ',' + this.customer.company_tax + ',' +  this.selectedGroup.name + ',' + this.selectedGroup.location.name + ',' + this.getParticipiantsList();
        
        const orderToSave = {
            status: status,
            remarks: this.remarks,
            reservation: this.reservation.id,
            group: this.selectedGroup.id,

            customer: this.customer.id,
            advance_amount: this.getAdvanceAmount(),
            total_amount: this.getTotalAmount(),
            monthly_amount: this.getMonthlyAmount(),
            currency: this.selectedGroup.currency || 'PLN',
            due_amount: this.getTotalAmount(),
            discount_amount: this.getDiscountAmount(),
            discount_code: this.discount?.code,
            addon_info: addonInfoString,

            participiants_count: this.getParticipantsCount(),
            participiants: participiants,
            // due_date: this.getDueDate(),
            details: this.getDetails(),
            keywords: order_keywords.substring(0, 255),
        };

        try {
            let response = null;
            const delays = [0, 1000, 2000]; // initial, then 1s, then 2s
            for (let attempt = 0; attempt < delays.length; attempt++) {
            if (attempt > 0) {
                await new Promise(res => setTimeout(res, delays[attempt]));
            }
            try {
                await this.selectedGroup.checkAvailability();
                if (this.selectedGroup.noAvailability) {
                    alert('Bardzo nam przykro, ale grupa, którą wybrałeś nie ma już wolnych miejsc. Prosimy o wybór innej grupy lub kontakt z nami w celu zapisania na listę rezerwową.');
                    return false;
                }
                response = await rpAPI.createOrder(orderToSave);
                // console.log('Order saved:', response);
                const orderId = response?.id;
                if (orderId) {
                    // RLO, wait for backend to process order
                    await new Promise(resolve => setTimeout(resolve, 3000));
                    this.sendOrder = await rpAPI.getOrderById(orderId);

                    // nie chcemy ju pamiętać zamówienia w localstorage
                    rpAPI.clearStorageItem('order', true);
                }
                break;
            } catch (err) {
                if (attempt === delays.length - 1) {
                throw err; // let outer catch handle final failure
                }
                console.warn(`Order save attempt ${attempt + 1} failed, retrying...`, err);
            }
            }
        } catch (error) {
            console.error('Order save error:', error);
            alert('Wystąpił błąd podczas zapisywania zamówienia. Proszę spróbować ponownie.');
            return false;
        }
        finally {
            return true;
        }
    }

    getParticipantsCount() {
        return Object.values(this.count).reduce((acc, c) => acc + c, 0);
    }

    getAdvanceAmount() {
        return 0;
        return this.getInstallmentPrice() + this.getInsuranceAmount();
    }

    getDueDate() {
        if (!this.selectedGroup || !this.selectedGroup.start_date) {
            return null;
        }
        // return term start date - 7 days
        const date = new Date(this.selectedGroup.start_date);
        date.setDate(date.getDate() - 30);
        return date.toISOString().split('T')[0];
    }

    isEligibleEarlyBird() {  
        return !!this.eligibleEearlyBird;
    }

    setIsEligibleEarlyBird(eligible) {
        this.eligibleEearlyBird = !!eligible;
    }

    isBeforeEnrollmentStart() {

        if (this.isEligibleEarlyBird()) return false;

        const enrollmentStart = this.selectedGroup?.enrollmentStart;
        return !!(enrollmentStart && enrollmentStart > Date.now());
    }

    getAdvancePaymentDate() {

        // current date + 3 days
        const date = new Date();
        // add 7 days to current date
        date.setDate(date.getDate() + 3);
        // format date 
        return date.toISOString().split('T')[0];
    }

    getInsuranceOptions(settings) {
        // let price = 0;
        // if (this.camp.insurance_type == "value") {
        //     price = this.camp.price_insurance * this.getParticipantsCount();
        // }
        // if (this.camp.insurance_type == "percent") {
        //     price = (this.getParticipiantsPrice() + this.getAddOnsPrice()) * this.camp.price_insurance;
        //     price = Math.ceil(price / 10) * 10; // Round up to the nearest multiple of 10
        // }
        // return [
        //     { id: 1, title: settings.insurance_label, short: this.camp.insurance_short ?? settings.insurance_short_default ?? "", price: price },
        //     { id: 2, title: settings.noinsurance_label, short: this.camp.noinsurance_short ?? settings.noinsurance_short_default ?? "", price: 0 },
        // ];
        return [];
    }

    static formatDate(dateString) {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString('pl-PL', options);
    }



}

export default Order;